import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { getUserAgamiListWithExpRelations, getUserAgamiList } from '../utils/helpers/user-spot.helpers'
import { AgamiSpot } from '../types/supabase'

interface UseUserAgamiListOptions {
  enabled?: boolean
  getExpRelations?: boolean
  getAudioUrls?: boolean
}

interface UseUserAgamiListReturn {
  agamiList: AgamiSpot[]
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useUserAgamiList = (options: UseUserAgamiListOptions = {}): UseUserAgamiListReturn => {
  const { user } = useSessionContext()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [agamiList, setAgamiList] = useState<AgamiSpot[]>([])
  const { enabled = true, getExpRelations, getAudioUrls } = options

  const fetchSpotsData = useCallback(async (): Promise<void> => {
    if (enabled === false) {
      return
    }

    const { spots, error } = getExpRelations
      ? await getUserAgamiListWithExpRelations({ userId: user!.id, getAudioUrls })
      : await getUserAgamiList({ userId: user!.id, getAudioUrls })

    if (error || !spots) {
      setIsLoading(false)
      return
    }

    setAgamiList(spots || [])
    setIsLoading(false)
  }, [user, enabled, getExpRelations, getAudioUrls])

  useEffect(() => {
    if (!user || enabled === false) {
      return
    }

    fetchSpotsData()
  }, [user, enabled, fetchSpotsData])

  return { agamiList, isLoading, refetch: fetchSpotsData }
}
